import { RemoteDeleteActivity } from 'data/usecases';
import { DeleteActivityUseCaseInterface } from 'domain/usecases';
import { makeApiUrlDeleteActivity } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeDeleteActivity = (): DeleteActivityUseCaseInterface =>
  new RemoteDeleteActivity(makeApiUrlDeleteActivity(), makeAxiosHttpClient());
